
module.exports = function()
{
    this.pinAllowed = true;
    this.onLogin = null;
}